'use strict';

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _get__("_interopRequireDefault")(_get__("_react"));

var _reactDom = require('react-dom');

var _reactDom2 = _get__("_interopRequireDefault")(_get__("_reactDom"));

var _propTypes = require('prop-types');

var _propTypes2 = _get__("_interopRequireDefault")(_get__("_propTypes"));

var _event = require('./utils/event');

var _scrollParent = require('./utils/scrollParent');

var _scrollParent2 = _get__("_interopRequireDefault")(_get__("_scrollParent"));

var _debounce = require('./utils/debounce');

var _debounce2 = _get__("_interopRequireDefault")(_get__("_debounce"));

var _throttle = require('./utils/throttle');

var _throttle2 = _get__("_interopRequireDefault")(_get__("_throttle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * react-lazyload
 */


var defaultBoundingClientRect = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0,
  height: 0
};
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = []; // try to handle passive events

var passiveEventSupported = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      _assign__("passiveEventSupported", true);
    }
  });
  window.addEventListener('test', null, _get__("opts"));
} catch (e) {} // if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!


var passiveEvent = _get__("passiveEventSupported") ? {
  capture: false,
  passive: true
} : false;
/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */

var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _get__("_reactDom2")["default"].findDOMNode(component);

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = _get__("defaultBoundingClientRect").top;
    parentLeft = _get__("defaultBoundingClientRect").left;
    parentHeight = _get__("defaultBoundingClientRect").height;
    parentWidth = _get__("defaultBoundingClientRect").width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth; // calculate top and height of the intersection of the element's scrollParent and viewport

  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport

  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport

  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height

  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width
  // check whether the element is visible in the intersection

  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = _get__("defaultBoundingClientRect").top;
    left = _get__("defaultBoundingClientRect").left;
    height = _get__("defaultBoundingClientRect").height;
    width = _get__("defaultBoundingClientRect").width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection

  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};
/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */


var checkNormalVisible = function checkNormalVisible(component) {
  var node = _get__("_reactDom2")["default"].findDOMNode(component); // If this element is hidden by css rules somehow, it's definitely invisible


  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = _get__("defaultBoundingClientRect").top;
    elementHeight = _get__("defaultBoundingClientRect").height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};
/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */


var checkVisible = function checkVisible(component) {
  var node = _get__("_reactDom2")["default"].findDOMNode(component);

  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _get__("_scrollParent2")["default"])(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? _get__("checkOverflowVisible")(component, parent) : _get__("checkNormalVisible")(component);

  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        _get__("pending").push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;

    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  _get__("pending").forEach(function (component) {
    var index = _get__("listeners").indexOf(component);

    if (index !== -1) {
      _get__("listeners").splice(index, 1);
    }
  });

  _assign__("pending", []);
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < _get__("listeners").length; ++i) {
    var listener = _get__("listeners")[i];

    _get__("checkVisible")(listener);
  } // Remove `once` component in listeners


  _get__("purgePending")();
}; // Depending on component's props


var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _get__("_inherits")(LazyLoad, _Component);

  function LazyLoad(props) {
    _get__("_classCallCheck")(this, LazyLoad);

    var _this = _get__("_possibleConstructorReturn")(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    return _this;
  }

  _get__("_createClass")(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (_get__("isString")(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }

      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && _get__("delayType") === 'throttle' || _get__("delayType") === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _get__("_event").off)(scrollport, 'scroll', _get__("finalLazyLoadHandler"), _get__("passiveEvent"));
        (0, _get__("_event").off)(window, 'resize', _get__("finalLazyLoadHandler"), _get__("passiveEvent"));

        _assign__("finalLazyLoadHandler", null);
      }

      if (!_get__("finalLazyLoadHandler")) {
        if (this.props.debounce !== undefined) {
          _assign__("finalLazyLoadHandler", (0, _get__("_debounce2")["default"])(_get__("lazyLoadHandler"), typeof this.props.debounce === 'number' ? this.props.debounce : 300));

          _assign__("delayType", 'debounce');
        } else if (this.props.throttle !== undefined) {
          _assign__("finalLazyLoadHandler", (0, _get__("_throttle2")["default"])(_get__("lazyLoadHandler"), typeof this.props.throttle === 'number' ? this.props.throttle : 300));

          _assign__("delayType", 'throttle');
        } else {
          _assign__("finalLazyLoadHandler", _get__("lazyLoadHandler"));
        }
      }

      if (this.props.overflow) {
        var parent = (0, _get__("_scrollParent2")["default"])(_get__("_reactDom2")["default"].findDOMNode(this));

        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(_get__("LISTEN_FLAG"));

          if (listenerCount === 1) {
            parent.addEventListener('scroll', _get__("finalLazyLoadHandler"), _get__("passiveEvent"));
          }

          parent.setAttribute(_get__("LISTEN_FLAG"), listenerCount);
        }
      } else if (_get__("listeners").length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;

        if (scroll) {
          (0, _get__("_event").on)(scrollport, 'scroll', _get__("finalLazyLoadHandler"), _get__("passiveEvent"));
        }

        if (resize) {
          (0, _get__("_event").on)(window, 'resize', _get__("finalLazyLoadHandler"), _get__("passiveEvent"));
        }
      }

      _get__("listeners").push(this);

      _get__("checkVisible")(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _get__("_scrollParent2")["default"])(_get__("_reactDom2")["default"].findDOMNode(this));

        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(_get__("LISTEN_FLAG")) - 1;

          if (listenerCount === 0) {
            parent.removeEventListener('scroll', _get__("finalLazyLoadHandler"), _get__("passiveEvent"));
            parent.removeAttribute(_get__("LISTEN_FLAG"));
          } else {
            parent.setAttribute(_get__("LISTEN_FLAG"), listenerCount);
          }
        }
      }

      var index = _get__("listeners").indexOf(this);

      if (index !== -1) {
        _get__("listeners").splice(index, 1);
      }

      if (_get__("listeners").length === 0 && typeof window !== 'undefined') {
        (0, _get__("_event").off)(window, 'resize', _get__("finalLazyLoadHandler"), _get__("passiveEvent"));
        (0, _get__("_event").off)(window, 'scroll', _get__("finalLazyLoadHandler"), _get__("passiveEvent"));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _get__("_react2")["default"].createElement('div', {
        style: {
          height: this.props.height
        },
        className: 'lazyload-placeholder'
      });
    }
  }]);

  return LazyLoad;
}(_get__("_react").Component);

_get__("LazyLoad").propTypes = {
  once: _get__("_propTypes2")["default"].bool,
  height: _get__("_propTypes2")["default"].oneOfType([_get__("_propTypes2")["default"].number, _get__("_propTypes2")["default"].string]),
  offset: _get__("_propTypes2")["default"].oneOfType([_get__("_propTypes2")["default"].number, _get__("_propTypes2")["default"].arrayOf(_get__("_propTypes2")["default"].number)]),
  overflow: _get__("_propTypes2")["default"].bool,
  resize: _get__("_propTypes2")["default"].bool,
  scroll: _get__("_propTypes2")["default"].bool,
  children: _get__("_propTypes2")["default"].node,
  throttle: _get__("_propTypes2")["default"].oneOfType([_get__("_propTypes2")["default"].number, _get__("_propTypes2")["default"].bool]),
  debounce: _get__("_propTypes2")["default"].oneOfType([_get__("_propTypes2")["default"].number, _get__("_propTypes2")["default"].bool]),
  placeholder: _get__("_propTypes2")["default"].node,
  scrollContainer: _get__("_propTypes2")["default"].oneOfType([_get__("_propTypes2")["default"].string, _get__("_propTypes2")["default"].object]),
  unmountIfInvisible: _get__("_propTypes2")["default"].bool
};
_get__("LazyLoad").defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _get__("_inherits")(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _get__("_classCallCheck")(this, LazyLoadDecorated);

        var _this2 = _get__("_possibleConstructorReturn")(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + _get__("getDisplayName")(WrappedComponent);
        return _this2;
      }

      _get__("_createClass")(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _get__("_react2")["default"].createElement(_get__("LazyLoad"), options, _get__("_react2")["default"].createElement(WrappedComponent, this.props));
        }
      }]);

      return LazyLoadDecorated;
    }(_get__("_react").Component);
  };
};

exports.lazyload = _get__("decorator");
exports["default"] = _get__("LazyLoad");
exports.forceCheck = _get__("lazyLoadHandler");

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "_interopRequireDefault":
      return _interopRequireDefault;

    case "_react":
      return _react;

    case "_reactDom":
      return _reactDom;

    case "_propTypes":
      return _propTypes;

    case "_scrollParent":
      return _scrollParent;

    case "_debounce":
      return _debounce;

    case "_throttle":
      return _throttle;

    case "passiveEventSupported":
      return passiveEventSupported;

    case "opts":
      return opts;

    case "_reactDom2":
      return _reactDom2;

    case "defaultBoundingClientRect":
      return defaultBoundingClientRect;

    case "_scrollParent2":
      return _scrollParent2;

    case "checkOverflowVisible":
      return checkOverflowVisible;

    case "checkNormalVisible":
      return checkNormalVisible;

    case "pending":
      return pending;

    case "listeners":
      return listeners;

    case "checkVisible":
      return checkVisible;

    case "purgePending":
      return purgePending;

    case "_inherits":
      return _inherits;

    case "_classCallCheck":
      return _classCallCheck;

    case "_possibleConstructorReturn":
      return _possibleConstructorReturn;

    case "_createClass":
      return _createClass;

    case "isString":
      return isString;

    case "delayType":
      return delayType;

    case "_event":
      return _event;

    case "finalLazyLoadHandler":
      return finalLazyLoadHandler;

    case "passiveEvent":
      return passiveEvent;

    case "_debounce2":
      return _debounce2;

    case "lazyLoadHandler":
      return lazyLoadHandler;

    case "_throttle2":
      return _throttle2;

    case "LISTEN_FLAG":
      return LISTEN_FLAG;

    case "_react2":
      return _react2;

    case "LazyLoad":
      return LazyLoad;

    case "_propTypes2":
      return _propTypes2;

    case "getDisplayName":
      return getDisplayName;

    case "decorator":
      return decorator;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {
    case "passiveEventSupported":
      return passiveEventSupported = _value;

    case "pending":
      return pending = _value;

    case "finalLazyLoadHandler":
      return finalLazyLoadHandler = _value;

    case "delayType":
      return delayType = _value;
  }

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (_typeof(variableName) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)["catch"](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = _typeof(module.exports);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(module.exports, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(module.exports)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}